import { Route, Routes, useLocation, Link } from 'react-router-dom';
import { useEffect, Suspense, lazy } from "react";
import Seo from './Seo';
import { CITY_BASE_PATH } from './cities';

// Lazy imports for better performance
const Header = lazy(() => import('./Component/Common/Header'));
const Footer = lazy(() => import('./Component/Common/Footer'));
const Home = lazy(() => import('./Component/Home'));
const Reason = lazy(() => import('./Component/Reason'));
const Services = lazy(() => import('./Component/Services'));
const WorkFlow = lazy(() => import('./Component/WorkFlow'));
const TestimonialSection = lazy(() => import('./Component/TestimonialSection '));
const Contact = lazy(() => import('./Component/Contact'));
const GalleryPage = lazy(() => import('./Component/Gallery'));
const Aboutus = lazy(() => import('./Component/Aboutus'));
const Toilets = lazy(() => import('./Component/Toilets'));
const ToiletVan = lazy(() => import('./Component/ToiletVan'));
const ToiletGreen = lazy(() => import('./Component/ToiletGreen'));
const ToiletOrange = lazy(() => import('./Component/ToiletOrange'));
const IndianToilet = lazy(() => import('./Component/IndianToilet'));
const Urinals = lazy(() => import('./Component/Urinals'));
const Heater = lazy(() => import('./Component/Heater'));
const CoolingSystem = lazy(() => import('./Component/CoolingSystem'));
const Cooler = lazy(() => import('./Component/Cooler'));
const MistFan = lazy(() => import('./Component/MistFan'));
const Ac = lazy(() => import('./Component/AC'));
const CityPage = lazy(() => import('./Component/CityPage'));
const PortableToiletsNearMe = lazy(() => import('./Component/PortableToiletsNearMe'));
const BlogList = lazy(() => import('./Component/BlogList'));
const BlogPost = lazy(() => import('./Component/BlogPost'));
const PrivacyPolicy = lazy(() => import('./Component/PrivacyPolicy'));
const HandWashStation = lazy(() => import('./Component/HandWashStation'));
const DeluxePremiumToiletPage = lazy(() => import('./Component/DeluxePremiumToiletPage'));
const MonthlyToiletRental = lazy(() => import('./Component/MonthlyToiletRental'));
const WesternMonthlyToilet = lazy(() => import('./Component/WesternMonthlyToilet'));


// Shown when someone opens an address that does not exist
const NotFound = () => (
  <div className="text-center py-20 px-4">
    <h1 className="text-3xl font-bold mb-4">Page not found</h1>
    <p className="mb-6">Sorry, we could not find that page.</p>
    <Link to="/" className="underline">Go to the AirLoo homepage</Link>
  </div>
);

// Layouts
const LandingLayout = () => (
  <>
    <Header />
    <Home />
    <Reason />
    <Services />
    <WorkFlow />
    <TestimonialSection />
    <Contact />
    <Footer />
  </>
);

const createPageLayout = (Component) => (
  <>
    <Header />
    <Component />
    <Footer />
  </>
);

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);

  return (
    <>
      {/* Sets the title, description and canonical link for every page */}
      <Seo />
      <Suspense fallback={<div className="text-center py-10 text-xl">Loading...</div>}>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingLayout />} />
            <Route path="/gallery" element={createPageLayout(GalleryPage)} />
            <Route path="/aboutus" element={createPageLayout(Aboutus)} />
            <Route path="/contactus" element={createPageLayout(Contact)} />
            <Route path="/services" element={createPageLayout(Services)} />
            <Route path="/toilets" element={createPageLayout(Toilets)} />
            <Route path="/toilet-van" element={createPageLayout(ToiletVan)} />
            <Route path="/bluestart-toilet" element={createPageLayout(ToiletGreen)} />
            <Route path="/premium-western-toilet" element={createPageLayout(ToiletOrange)} />
            <Route path="/indian-toilet" element={createPageLayout(IndianToilet)} />
            <Route path="/urinals" element={createPageLayout(Urinals)} />
            <Route path="/heater" element={createPageLayout(Heater)} />
            <Route path="/cooling-system" element={createPageLayout(CoolingSystem)} />
            <Route path="/cooler" element={createPageLayout(Cooler)} />
            <Route path="/mistfan" element={createPageLayout(MistFan)} />
            <Route path="/ac" element={createPageLayout(Ac)} />
            <Route path={CITY_BASE_PATH} element={createPageLayout(CityPage)} />
            <Route path={`${CITY_BASE_PATH}/:slug`} element={createPageLayout(CityPage)} />
            <Route path="/portable-toilets-near-me" element={createPageLayout(PortableToiletsNearMe)} />
            <Route path="/blog" element={createPageLayout(BlogList)} />
            <Route path="/blog/:slug" element={createPageLayout(BlogPost)} />
            <Route path="/privacy-policy" element={createPageLayout(PrivacyPolicy)} />
            <Route path="/handwash" element={createPageLayout(HandWashStation)} />
            <Route path="/deluxe-premium-toilet" element={createPageLayout(DeluxePremiumToiletPage)} />
            <Route path="/portable-toilet-monthly-rent" element={createPageLayout(MonthlyToiletRental)} />
            <Route path="/western-toilet-monthly-rent" element={createPageLayout(WesternMonthlyToilet)} />

            <Route path="*" element={createPageLayout(NotFound)} />
          </Routes>
        </div>
      </Suspense>
    </>
  );
}

export default App;